/**
 * ControlledDrugBadge
 * Shows a small amber "CD" chip next to item names that are controlled drugs.
 * Used in: ItemList name column, anywhere item names are displayed.
 * Props: { show: boolean }
 */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { IPD_COLORS } from '../theme';
import { invChipSx } from './StatusChip';

export default function ControlledDrugBadge({ show }) {
  if (!show) return null;

  return (
    <Tooltip title="Controlled drug — handle with care" arrow>
      <Chip
        label="CD"
        size="small"
        sx={{
          ...invChipSx({ color: IPD_COLORS.warning.text, variant: 'soft', size: 'xs' }),
          cursor: 'default',
        }}
      />
    </Tooltip>
  );
}
